import React from "react";
import { useParams } from "react-router-dom";
import DomainSearch from "../DomainSalesSearch";
import DomainPurchaseSuccess from "../DomainSalesSearch/components/DomainPurchaseSuccess/DomainPurchaseSuccess";
import DomainCartPage from "../DomainSalesSearch/components/CartPage";
import Payment from "../Payment";
import { DOMAIN_CART_PAGE, DOMAIN_PURCHASE_SUCCESS, DOMAIN_REQUEST_TO_CALLBACK, DOMAIN_SEARCH_PAGE, PAYMENT } from "../../Constants/routesConstant";

const DomainLandingPage = () => {
  const params: any = useParams();
  let { path } = params;
  path = `/${path}`; // Appends slash to match with the constant declared in routeConstants.

  switch (path) {
    case DOMAIN_SEARCH_PAGE:
      return <DomainSearch />;
    case DOMAIN_PURCHASE_SUCCESS:
      return <DomainPurchaseSuccess />;
    case DOMAIN_CART_PAGE:
      return <DomainCartPage />;
    case PAYMENT:
      return <Payment />;
    case DOMAIN_REQUEST_TO_CALLBACK: 
      return <DomainSearch requestToCallback={true} />;
  }

  return <></>;
};

export default DomainLandingPage;
